module.exports = __webpack_public_path__ + "media/images/frontend/blue-ed77791c02b48c9faf130f043abac53d.png";